export function footerFunc() {
}

export function footerScrFunc() {
  var contactBtn = $('.contact-btn');
  var totoptBtn = $('.totop-btn');
  var scroll = $(window).scrollTop();
  if(scroll > 100) {
    contactBtn.addClass('show');
    totoptBtn.addClass('show');
  } else {
    contactBtn.removeClass('show');
    totoptBtn.removeClass('show');
  }
}